// タイムラインの別事業所ガード（onChange/onDrop）で使う会社解決・突合ロジック。
// 「指定なし」（truckId === -1 の仮想レーン）は temporaryTruck が truckData 自体には
// 含まれない（Component.tsx で filteredTruckData にのみ push される）ため、
// truck→garage 経由の解決では常に unresolved になる。これを実トラックの解決失敗
// （拒否すべきケース）と区別するため、virtual として明示的に扱う。

export type CompanyResolution =
  | { kind: 'virtual' }
  | { kind: 'resolved'; companyId: number }
  | { kind: 'unresolved' };

type DeliveryLike = { truckId: number } | undefined;
type TruckLike = { id: number; garageId: number };
type GarageLike = { id: number; companyId: number };

// シフト（デリバリー）の会社を truck→garage 経由で解決する。
// truckId === -1 は「指定なし」の仮想レーンなので virtual を返す（会社チェック対象外）。
export const resolveDeliveryCompany = (
  delivery: DeliveryLike,
  truckData: TruckLike[] | undefined,
  garageData: GarageLike[] | undefined,
): CompanyResolution => {
  if (!delivery) return { kind: 'unresolved' };
  if (delivery.truckId === -1) return { kind: 'virtual' };

  const truck = truckData?.find((t) => t.id === delivery.truckId);
  if (!truck) return { kind: 'unresolved' };

  const companyId = garageData?.find((g) => g.id === truck.garageId)?.companyId;
  if (companyId === undefined) return { kind: 'unresolved' };

  return { kind: 'resolved', companyId };
};

// onChange（既存イベントの移動）用の突合。
// - virtual（指定なしレーン）が関わる場合は会社チェック対象外＝許可（false）。
// - 実トラックの会社解決に失敗（unresolved）した場合は拒否（true）。
// - どちらも resolved なら companyId の一致で判定する。
export const isCrossCompanyMove = (before: CompanyResolution, destination: CompanyResolution): boolean => {
  if (before.kind === 'virtual' || destination.kind === 'virtual') return false;
  if (before.kind === 'unresolved' || destination.kind === 'unresolved') return true;
  return before.companyId !== destination.companyId;
};

// onDrop（新規案件の投入）用の突合。投入先シフトの会社解決結果と、案件自身の company_id を比較する。
// - シフトが virtual（指定なしレーン）なら会社チェック対象外＝許可（false）。
// - シフトの会社解決に失敗（unresolved）した場合は拒否（true）。
export const isCrossCompanyDrop = (shift: CompanyResolution, orderCompanyId: number): boolean => {
  if (shift.kind === 'virtual') return false;
  if (shift.kind === 'unresolved') return true;
  return shift.companyId !== orderCompanyId;
};
